import { HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http'

const IGNORE_HEADER_OVERRIDE = new HttpContextToken<boolean>(() => false)
export const ignoreHeaderOverride = () => new HttpContext().set(IGNORE_HEADER_OVERRIDE, true)

export const jsonContentTypeInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(IGNORE_HEADER_OVERRIDE)) {
    return next(request)
  }

  return next(
    request.clone({
      headers: request.headers.append('Content-Type', 'application/json-patch+json'),
    }),
  )
}
